import request from '@/utils/request'
import { downloadBlob } from '@/utils/download'

// REQ-2026-632570 客诉反馈 —— 管理端接口
// 路径由三方共用规格（REQ-2026-632570-spec.md）约定，不得自行更改
const apiPath = '/complaint/feedback'

const customerComplaintApi = {
  /**
   * 分页查询【客诉反馈】
   */
  fetchList(query) {
    return request.get(`${apiPath}/page`, { params: query })
  },
  /**
   * 顶部五个统计卡计数
   */
  statistics(query) {
    return request.get(`${apiPath}/statistics`, { params: query })
  },
  /**
   * 查看【客诉反馈】详情（含处理记录时间轴 + 内部备注）
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 保存处理 / 完成处理
   * 入参：id、handlerId、state、handleOpinion、innerRemark
   */
  handle(data) {
    return request.post(`${apiPath}/handle`, data)
  },
  /**
   * 回复客户
   */
  reply(data) {
    return request.post(`${apiPath}/reply`, data)
  },
  /**
   * 新增内部备注（已归档的记录后端会拒绝）
   */
  remark(data) {
    return request.post(`${apiPath}/remark`, data)
  },
  /**
   * 归档
   */
  archive(data) {
    return request.post(`${apiPath}/archive`, data)
  },
  /**
   * 导出数据（与列表同一套筛选条件）
   */
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '客诉反馈.xlsx'))
  },
  /**
   * 批量导出（勾选的 id 列表）
   */
  batchExport(ids) {
    return request.post(`${apiPath}/batchExport`, ids, { responseType: 'blob' })
      .then(res => downloadBlob(res, '客诉反馈.xlsx'))
  }
}

export default customerComplaintApi
